import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setTradeDetails } from "../../../utils/store/reducers/accountMetricsSlice";
import CandleStickChart from "./CandleStickChart.jsx";
import TradeDetailsCard from "./TradeDetailsCard.jsx";
import { useLocation } from "react-router-dom";
import { normalizeTradeData } from "../../../utils/helpers/trade";

// Utility to get start and end of day for a given date string (now for open and close times)
const getDayRange = (openTime, closeTime) => {
  if (!openTime && !closeTime) return { start: undefined, end: undefined };
  // Prefer openTime, fallback to closeTime
  const dateString = openTime || closeTime;
  const datePart = dateString.split("T")[0];
  return {
    start: `${datePart}T00:00:00`,
    end: `${datePart}T23:59:59`,
  };
};

const TradeDetailsPage = () => {
  useLocation();

  let tradeData = useSelector((state) => state.accountMetrics?.tradeDetails);

  // Normalize tradeData to a common shape
  const normalizedTrade = normalizeTradeData(tradeData);

  // Extract required fields for CandleStickChart
  const symbol = normalizedTrade?.symbol;
  const openTrade = normalizedTrade?.open_time;
  const closeTrade = normalizedTrade?.close_time;

  const { start: startDate, end: endDate } = getDayRange(openTrade, closeTrade);
  // You can adjust timeFrame and color as needed
  const color = normalizedTrade?.pnl > 0 ? "#26a69a" : "#ef5350";
  // useEffect(() => {
  //   if (!tradeData) {
  //     navigate("/trading-history");
  //   }
  // }, [tradeData, navigate]);
  // Add at the top of CandleStickChart
  const [theme, setTheme] = useState("dark"); // 'light' or 'dark'

  // Function to toggle theme
  const handleThemeToggle = () => setTheme(theme === "dark" ? "light" : "dark");
  const [maeMfedetails, setMaeMfedetails] = useState();

  return (
    <div className={`view-trade-container ${theme}-mode`}>
      <CandleStickChart
        symbol={symbol}
        startDate={startDate}
        endDate={endDate}
        color={color}
        tradeData={normalizedTrade}
        theme={theme}
        handleThemeToggle={handleThemeToggle}
        setMaeMfedetails={setMaeMfedetails}
      />
      {/* Optionally, show trade details below the chart */}
      <TradeDetailsCard trade={normalizedTrade} maeMfedetails={maeMfedetails} />
    </div>
  );
};

export default TradeDetailsPage;
